export const LocaleDateFilter = (
  date: Date,
  locale: string = "es-EC"
): string => {
  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "long",
    day: "2-digit",
  }).format(date);
};

export const convertTimeToLocal = (date: Date) => {
  // Si el backend manda fecha sin timezone info, parsear como local
  if (typeof date === 'string') {
    const str = (date as string).endsWith('Z') 
      ? (date as string).slice(0, -1)  // quita la Z
      : date as string
    return new Date(str)
  }
  return date
}

export const formatDate = (date: Date) => {
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  
  // Mediodia local evita cualquier desfase por zona horaria
  return new Date(year, month, day, 12, 0, 0)
}
